module.exports = __webpack_public_path__ + "static/img/bj.a0f63542.png";